// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2d9Nd","content":"LoadingAlert_content__TlYIE"};